import React, { useEffect, useState } from 'react';
import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import ApiService from '../../../services/ApiService';
import moment from 'moment';
import DifficultyPriorityTable from './DifficultyPriorityTable';

const DetailInput = ({
  onDetailAdded,
  onDetailUpdated,
  detail = null,
  setOpen,
  difficultyPriorityData = null,
  actionHeader = null,
}) => {
  const [formData, setFormData] = useState({
    id: 0,
    idRekomendasiLapInvest: 0,
    pembahasan: '',
    tindakLanjut: '',
    picEmail: '',
    picDisplayName: '',
    picJabatan: '',
    reviewerEmail: '',
    reviewerDisplayName: '',
    reviewerJabatan: '',
    fungsiId: 0,
    fungsiName: '',
    priority: 0,
    tingkatKesulitan: 0,
    dueDate: moment().add(30, 'days').format('DD-MMMM-YYYY').toString(),
    dueDateCreator: null,
    dueDateExtend: null,
    status: '',
    idStatus: '',
    remark: '',
  });

  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [fungsi, setFungsi] = useState([]);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    if (detail) {
      setIsEdit(true);
      setFormData({
        ...detail,
        dueDate: moment(detail.dueDateCreator || detail.dueDate) // this handle existing detail from api, if dueDateCreator is null, then use dueDate (editing non existing detail)
          .format('DD-MMMM-YYYY')
          .toString(),
      });
      setUsers([
        {
          email: detail.picEmail,
          namalengkap: detail.picDisplayName,
          jabatan: detail.picJabatan,
        },
        {
          email: detail.reviewerEmail,
          namalengkap: detail.reviewerDisplayName,
          jabatan: detail.reviewerJabatan,
        },
      ]);
    }

    getFungsi();
  }, [detail]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleAddDetail = (event) => {
    event.preventDefault();
    onDetailAdded(formData);
  };

  const handleUpdateDetail = (event) => {
    event.preventDefault();
    onDetailUpdated(formData);
  };

  const getUsers = async (val) => {
    setIsLoading(true);
    try {
      await ApiService.getListUserAdmin(val).then((res) => {
        if (res.data.isOk) {
          setUsers(
            res.data.payload.map((user) => ({
              email: user.email,
              namalengkap: user.namalengkap,
              jabatan: user.jabatan,
            }))
          );
        } else {
          alert(res.data.message);
          setTimeout(() => {
            // router("/");
          }, 500);
        }
        setIsLoading(false);
      });
    } catch (error) {
      setIsLoading(false);
      alert('The Error was occured', error);
      setTimeout(() => {
        // router("/");
      }, 500);
    }
  };

  const getFungsi = async () => {
    setIsLoading(true);
    try {
      await ApiService.getFungsiActionTracking().then((res) => {
        if (res.data.isOk) {
          setFungsi(
            res.data.payload.map((fungsi) => ({
              id: fungsi.id,
              name: fungsi.name,
            }))
          );
        } else {
          alert(res.data.message);
          setTimeout(() => {}, 500);
        }
        setIsLoading(false);
      });
    } catch (error) {
      setIsLoading(false);
      alert('The Error was occured', error);
      setTimeout(() => {}, 500);
    }
  };

  const handleKeyDown = async (e) => {
    setIsLoading(true);
    if ((e.key == 'Enter' || e.key == ' ') && e.target.value.length >= 5) {
      await getUsers(e.target.value);
    }
    setIsLoading(false);
  };

  const handleFungsiKeyDown = async (e) => {
    setIsLoading(true);
    if ((e.key == 'Enter' || e.key == ' ') && e.target.value.length >= 5) {
      await getFungsi(e.target.value);
    }
    setIsLoading(false);
  };

  const handlePicChange = (e, value) => {
    if (value === null) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        picEmail: '',
        picDisplayName: '',
        picJabatan: '',
      }));
      return;
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      picEmail: value.email,
      picDisplayName: value.namalengkap,
      picJabatan: value.jabatan === '' ? '-' : value.jabatan,
    }));
  };

  const handleReviewerChange = (e, value) => {
    if (value === null) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        reviewerEmail: '',
        reviewerDisplayName: '',
        reviewerJabatan: '',
      }));
      return;
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      reviewerEmail: value.email,
      reviewerDisplayName: value.namalengkap,
      reviewerJabatan: value.jabatan === '' ? '-' : value.jabatan,
    }));
  };

  const handleFungsiChange = (e, value) => {
    if (value === null) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        fungsiId: 0,
      }));
      return;
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      fungsiId: value.id,
    }));
  };

  return (
    <Grid container alignItems="center">
      <Grid item xs={12}>
        <Typography variant="h6" marginTop={4}>
          Detail Pembahasan
        </Typography>
      </Grid>

      <Grid item xs={12} marginBottom={2}>
        <FormControl fullWidth>
          <TextField
            label="Pembahasan"
            name="pembahasan"
            value={formData.pembahasan}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            readOnly
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} marginBottom={2}>
        <FormControl fullWidth>
          <TextField
            label="Tindak Lanjut"
            name="tindakLanjut"
            value={formData.tindakLanjut}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            readOnly
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} marginBottom={2}>
        <FormControl fullWidth>
          <Autocomplete
            loading={isLoading}
            name="picEmail"
            onChange={handlePicChange}
            onKeyDown={handleKeyDown}
            required
            getOptionLabel={(option) =>
              `${option.namalengkap} - ${option.jabatan}`
            }
            options={users}
            renderInput={(params) => <TextField {...params} label="PIC" />}
            defaultValue={
              detail
                ? {
                    namalengkap: detail?.picDisplayName,
                    jabatan: detail?.picJabatan,
                    email: detail?.picEmail,
                  }
                : null
            }
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} marginBottom={2}>
        <FormControl fullWidth>
          <Autocomplete
            loading={isLoading}
            name="reviewerEmail"
            onChange={handleReviewerChange}
            onKeyDown={handleKeyDown}
            required
            getOptionLabel={(option) =>
              `${option.namalengkap} - ${option.jabatan}`
            }
            options={users}
            renderInput={(params) => <TextField {...params} label="Reviewer" />}
            defaultValue={
              detail
                ? {
                    namalengkap: detail?.reviewerDisplayName,
                    jabatan: detail?.reviewerJabatan,
                    email: detail?.reviewerEmail,
                  }
                : null
            }
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} marginBottom={2}>
        <FormControl fullWidth>
          <Autocomplete
            loading={isLoading}
            name="fungsi"
            onChange={handleFungsiChange}
            onKeyDown={handleFungsiKeyDown}
            required
            getOptionLabel={(option) => `${option.name}`}
            options={fungsi}
            renderInput={(params) => <TextField {...params} label="Fungsi" />}
            defaultValue={
              detail
                ? {
                    name: detail?.fungsiName,
                    id: detail?.fungsiId,
                  }
                : null
            }
          />
        </FormControl>
      </Grid>

      <Grid item justifyContent="space-between" container marginBottom={3}>
        <FormControl sx={{ width: '49%' }}>
          <InputLabel>Priority (Risk)</InputLabel>
          <Select
            name="priority"
            value={formData.priority}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            label="Priority (Risk)"
            disabled={
              detail &&
              detail.id &&
              detail.priority &&
              actionHeader &&
              (actionHeader.statusHeaderName === 'Open' ||
                actionHeader.statusHeaderName === 'On Progress' ||
                actionHeader.statusHeaderName === 'In Progress')
            }
          >
            <MenuItem value={1}>Low</MenuItem>
            <MenuItem value={2}>Medium</MenuItem>
            <MenuItem value={3}>High</MenuItem>
          </Select>
        </FormControl>

        <FormControl sx={{ width: '49%' }}>
          <InputLabel>Tingkat Kesulitan</InputLabel>
          <Select
            name="tingkatKesulitan"
            value={formData.tingkatKesulitan}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            label="Tingkat Kesulitan"
            disabled={
              detail &&
              detail.id &&
              detail.tingkatKesulitan &&
              actionHeader &&
              (actionHeader.statusHeaderName === 'Open' ||
                actionHeader.statusHeaderName === 'On Progress' ||
                actionHeader.statusHeaderName === 'In Progress')
            }
          >
            <MenuItem value={1}>Mudah / Otorisasi Lokasi</MenuItem>
            <MenuItem value={2}>Menengah / Otorisasi Region</MenuItem>
            <MenuItem value={3}>Sulit / Otorisasi SH</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} marginBottom={2}>
        <FormControl fullWidth>
          <DesktopDatePicker
            label="Due Date"
            name="dueDate"
            variant="standard"
            value={formData?.dueDate}
            inputFormat="DD-MMMM-YYYY"
            onChange={(value) =>
              setFormData({
                ...formData,
                dueDate: value.format('DD-MMMM-YYYY').toString(),
              })
            }
            disableMaskedInput
            renderInput={(renderInput) => (
              <TextField
                {...renderInput}
                disabled={
                  detail &&
                  detail.id &&
                  actionHeader &&
                  (actionHeader.statusHeaderName === 'Open' ||
                    actionHeader.statusHeaderName === 'On Progress' ||
                    actionHeader.statusHeaderName === 'In Progress')
                }
              />
            )}
            disabled={
              detail &&
              detail.id &&
              actionHeader &&
              (actionHeader.statusHeaderName === 'Open' ||
                actionHeader.statusHeaderName === 'On Progress' ||
                actionHeader.statusHeaderName === 'In Progress')
            }
          />
        </FormControl>
      </Grid>

      {formData?.dueDateExtend && (
        <Grid item xs={12} marginBottom={2}>
          <FormControl fullWidth>
            <DesktopDatePicker
              label="Due Date Extend"
              name="dueDateExtend"
              variant="standard"
              value={formData?.dueDateExtend}
              inputFormat="DD-MMMM-YYYY"
              onChange={(value) =>
                setFormData({
                  ...formData,
                  dueDateExtend: value.format('DD-MMMM-YYYY').toString(),
                })
              }
              disableMaskedInput
              renderInput={(renderInput) => (
                <TextField
                  {...renderInput}
                  disabled={
                    detail &&
                    detail.id &&
                    actionHeader &&
                    (actionHeader.statusHeaderName === 'Open' ||
                      actionHeader.statusHeaderName === 'On Progress' ||
                      actionHeader.statusHeaderName === 'In Progress')
                  }
                />
              )}
              disabled={
                detail &&
                detail.id &&
                actionHeader &&
                (actionHeader.statusHeaderName === 'Open' ||
                  actionHeader.statusHeaderName === 'On Progress' ||
                  actionHeader.statusHeaderName === 'In Progress')
              }
            />
          </FormControl>
        </Grid>
      )}

      <Grid item xs={12} marginBottom={2}>
        <DifficultyPriorityTable
          difficultyPriorityData={difficultyPriorityData}
        />
      </Grid>

      <Grid item xs={12} marginBottom={2}>
        {detail ? (
          <Button
            variant="contained"
            color="primary"
            onClick={handleUpdateDetail}
          >
            Update Pembahasan
          </Button>
        ) : (
          <Button variant="contained" color="primary" onClick={handleAddDetail}>
            Save Pembahasan
          </Button>
        )}

        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpen(false)}
          sx={{ marginLeft: 2 }}
        >
          Cancel
        </Button>
      </Grid>
    </Grid>
  );
};

export default DetailInput;
